import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Stricter than Angular's built-in Validators.email: requires a top-level
// domain after the @ (e.g. rejects "davor@google", accepts "davor@google.com").
const STRICT_EMAIL_REGEX =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function strictEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (value == null || value === '') return null;
        return STRICT_EMAIL_REGEX.test(String(value)) ? null : { email: true };
    };
}
